import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const createInvestmentFund = async (formValues, succesMsg, errorMsg, navigate) => {
    try {
        const { data } = await faradayApi.post('/investmentsFunds', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate(-1)
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
    }
}

export const editInvestmentFund = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.put(`/investmentsFunds`, formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
    }
}

export const deleteInvestmentFund = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const {value} = await Swal.fire({
        text: `${deleteConfirm} ${e.row.whoInvest}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
      })
    value && onConfirm(e.row.id, succesMsg, errorMsg, e.row.whoInvest)
}

const onConfirm = async (id, succesMsg, errorMsg, name) => {
    const { data } = await faradayApi.delete('/investmentsFunds', { data: { id } });

        data.data !== 0 && !data.error  ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${name} ${succesMsg}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })       
}